import React from "react";
import {
  Link
} from "react-router-dom";
import config from './../../config.js';
import Header from './../common/header';
import Footer from './../common/footer';
import './../../../style/home.css';
import './../../../style/signin.css';

import thirdparty from './../../../utils/thirdparty.js';

import Notification from 'rc-notification';
let notification = null;
Notification.newInstance({
  style: {
    top: '45px',
    right: 0
  }
}, (n) => notification = n);
export default class Register extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      username: '',
      password: '',
      repassword: '',
      invitationcode: '',
      type: 'register',
      isnotify: false,
      notify: '',
      logo: '',
      company_id: 1,
      company_name: '',
      agreeDeclaration: false
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') props.history.push('/console');

  }


  componentDidMount() {
    let company = localStorage.company_detail;

    if (typeof company == 'undefined') {
      const me = this;
      const company = thirdparty.getCompany();
      company.then((res) => {
        if (typeof res.company_detail != 'undefined') {
          me.setState({
            logo: res.company_detail.logo,
            company_id: res.company_detail.user_id,
            company_name: res.company_detail.name
          });

        }
      })
    } else {
      company = JSON.parse(company);
      this.setState({
        company_id: company.user_id,
        logo: company.logo
      });
    }

  }


  notify(message) {
    notification.notice({
      content: <span>{message}</span>,
      duration: 4,
      style: {
        'bottom': 0,
        'right': 0
      }
    });
  }


  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    //const value = target.value;
    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    const me = this;
    fetch(config.host + '/user/index/', {
      method: 'post',
      body: JSON.stringify(me.state)
    })
      .then(res => res.json())
      .then(json => {
        //console.log(json);
        if (json.status === 200) {

          const data = json.data;
          console.log(data);
          localStorage.token = data.token;
          localStorage.user = JSON.stringify(data.userinfo);

          me.props.history.push('/console');
        } else {
          me.notify(json.message);
        }
      })
      .catch(error => {
        console.log(error);
      });
    return;
  }

  onKeyDown(event: React.KeyboardEvent<HTMLDivElement>) {
    // 'keypress' event misbehaves on mobile so we track 'Enter' key via 'keydown' event
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      this.handleSubmit();
    }
  }


  checkDeclaration() {
    const agreeDeclaration = this.state.agreeDeclaration;
    this.setState({
      agreeDeclaration: !agreeDeclaration
    })
  }


  render() {
    const me = this;
    const {
      agreeDeclaration
    } = me.state;
    return (
      <div>
        <Header company_name={this.state.company_name} />

        <form className="form-signup mt-5 mb-5 mx-auto" onSubmit={this.handleSubmit}>
          <p className="text-center"><img src={this.state.logo} className="logo" alt="" /></p>
          <h4>新用户注册</h4>
          <div className="form-row mt-3">
            <div className="form-group col-md-6">
              <label>电子邮箱</label>
              <input name="email" type="email" className="form-control" placeholder="Email" title="Email address" required autoFocus onChange={this.handleInputChange} value={this.state.email} />
            </div>
            <div className="form-group col-md-6">
              <label>用户名</label>
              <input name="username" type="text" className="form-control" placeholder="Username" title="Username" required onChange={this.handleInputChange} value={this.state.username} />
            </div>
          </div>
          <div className="form-row mt-3">
            <div className="form-group col-md-6">
              <label>设置密码</label>
              <input name="password" type="password" className="form-control" placeholder="Password" title="Password" required onChange={this.handleInputChange} value={this.state.password} />
            </div>
            <div className="form-group col-md-6">
              <label>确认密码</label>
              <input name="repassword" type="password" className="form-control" placeholder="Password Confirmation" title="Password Confirmation" required onChange={this.handleInputChange} value={this.state.repassword} />
            </div>
          </div>

          <div className="form-row mt-3">
            <div className="form-group col-md-6">
              <label>邀请码</label>
              <input name="invitationcode" type="text" className="form-control" placeholder="Invitation code" title="Invitation code" required onChange={this.handleInputChange} value={this.state.invitationcode} />
            </div>
          </div>

          <div className="form-group">
            <div className="form-check">
              <label className="form-check-label">
                <input className="form-check-input" type="checkbox" name="agreeDeclaration" checked={agreeDeclaration} onChange={this.handleInputChange} />
                同意<Link to={'/sign/declaration'} target="_blank">使用声明</Link>
              </label>
            </div>
          </div>
          <button type="submit" className="btn btn-primary" title="Sign Up">注 册 </button>
          <div className="mt-3">
            <Link to={`/`}>已有账户，登录</Link>
          </div>
        </form>
        <Footer />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/apps/site/sign/register.js